import Footer from "../components/Footer";
import Features from "../components/Features";
import Category2 from "./Category2";
import { Link } from "react-router-dom";
import React, {useEffect, useState} from "react";
import Products from "./Products";
import { useSearchParams } from "react-router-dom";
import MetaComponent from "../components/MetaComponent";
import Header from "../components/Header";


const metadata = {
    title: `Products || ${process.env.REACT_APP_META_TITLE}`,
    description: process.env.REACT_APP_META_DESCRIPTION,
};


export default function ProductListPage({onPageReady}) {


    const [readyProduct, setReadyProduct] = useState(false);
    const [readyCategory, setReadyCategory] = useState(false);

    useEffect(() => {
        if (readyProduct && readyCategory) {
            onPageReady?.();
        }
    }, [readyProduct, readyCategory]);

    const [searchParams] = useSearchParams();

    const filters = {
        category: searchParams.get("category") || null,
        gender: searchParams.get("gender") || null,
        collection: searchParams.get("collection") || null,
        search: searchParams.get("search") || null,
    };

    const pageTitle = filters.gender === 'male'
        ? 'Men'
        : filters.gender === 'female'
            ? 'Women'
            : 'All Products';


    return (
        <>
            <MetaComponent meta={metadata} />
            <Header />
            <Category2 onLoaded={() => setReadyCategory(true)} />
            <>
                {/* Breadcrumb */}
                <div className="tf-breadcrumb mt-0">
                    <div className="container">
                        <ul className="breadcrumb-list">
                            <li className="item-breadcrumb">
                                <Link to={`/`} className="text">
                                    Home
                                </Link>
                            </li>
                            <li className="item-breadcrumb dot">
                                <span />
                            </li>
                            <li className="item-breadcrumb">
                                <Link to={`/category-list`} className="text">
                                    Collections
                                </Link>
                            </li>
                            <li className="item-breadcrumb dot">
                                <span />
                            </li>
                            <li className="item-breadcrumb">
                                <span className="text">Products</span>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* /Breadcrumb */}
                {/* Title Page */}
                <section className="page-title flat-spacing-4 pt-0">
                    <div className="container">
                        <div className="box-title text-center justify-items-center">
                            <h4 className="title">{pageTitle}</h4>
                            <p className="text-main text-md">
                                Discover our newest collection crafted for modern living.
                                Clean lines, refined textures, and effortless versatility — made to move with you.
                            </p>
                            <Link to="/about-us" className="tf-btn btn-out-line-dark2">
                                Read More
                            </Link>
                        </div>
                    </div>
                </section>
            </>

            <Products
                filterParams={filters}
                onLoaded={() => setReadyProduct(true)}
            />
            <Features />
            <Footer />
        </>
    );
}
